import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Repeatable bottom CTA strip. Used at the foot of every sub-page.
 * Evergreen defaults — BRep is a live platform.
 */
export default function CTAStrip({
  eyebrow = "Get Started",
  title = "Ready when you are.",
  subtitle = "Browse services, find a coach, or download the app.",
  primary = { to: "/services", label: "View Services" },
  secondary = null,
}) {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-12 border-t border-white/10" data-testid="cta-strip">
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-8">
          <div className="text-[11px] tracking-[0.32em] uppercase text-[#2A5BFF] mb-4">{eyebrow}</div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="font-anton uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight max-w-3xl"
          >
            {title}
          </motion.h2>
          {subtitle && <p className="mt-6 text-white/60 max-w-xl">{subtitle}</p>}
        </div>
        <div className="md:col-span-4 flex flex-col sm:flex-row md:flex-col md:items-end gap-4">
          <Link
            to={primary.to}
            className="btn-primary group inline-flex items-center gap-3 px-6 py-4 text-[12px] tracking-[0.22em] uppercase font-medium"
            data-testid="cta-primary"
          >
            {primary.label}
            <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
          {secondary && (
            <Link
              to={secondary.to}
              className="btn-ghost group inline-flex items-center gap-3 px-6 py-4 text-[12px] tracking-[0.22em] uppercase font-medium"
              data-testid="cta-secondary"
            >
              {secondary.label}
              <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
